import { BordTextButton } from 'bord-design-system';
import { bordColorTheme } from 'styles/styles.constants';
import { IToolSearchResult } from 'types/quoteEditor.types';
import BordProductImageWithBrand from 'components/NudosComponents/BordProductImageWithBrand/BordProductImageWithBrand';
import './SelectedToolHeader.scss';

interface ISelectedToolHeader {
  tool: IToolSearchResult;
  onChangeTool: () => void;
  isChangeToolDisabled?: boolean;
}

/**
 * Cabecera de identificación de una herramienta seleccionada en el panel de sugerencia.
 * Muestra imagen, nombre, SKU con link al catálogo, badge "En tienda" si aplica,
 * y botón para cambiar la herramienta.
 */
const SelectedToolHeader = ({ tool, onChangeTool, isChangeToolDisabled }: ISelectedToolHeader) => {
  const goToCatalogProduct = () => {
    if (!tool.categoryId || !tool.id) return;
    window.open(`/catalog/create-product/${tool.categoryId}?productId=${tool.id}`, '_blank');
  };

  return (
    <div className="selectedToolHeader">
      <BordProductImageWithBrand imageUrl={tool.imageUrl} brandImageUrl={tool.brandImage} />
      <div className="toolInfo">
        <div className="toolName">{tool.name}</div>
        {tool.sku && (
          <div className="toolSku">
            <span className="skuText">SKU {tool.sku}</span>
            {tool.categoryId && (
              <BordTextButton
                text=""
                onClick={goToCatalogProduct}
                rightIconProps={{ variant: 'externalLink', standardSize: 12, stroke: bordColorTheme.cyan[400] }}
              />
            )}
          </div>
        )}
      </div>
      {!isChangeToolDisabled && (
        <button className="changeToolBtn" onClick={onChangeTool}>
          Cambiar
        </button>
      )}
    </div>
  );
};

export default SelectedToolHeader;
